<template>
  <div>
    <b-card class='text-center'>
      <i class="fad fa-user"></i>
      <br>
      Person added to sequence
      <span v-if='recipient && recipient.started'><br>{{recipient.started | datetime}}</span>
    </b-card>

    <div v-for="(thread, $thread_index) in threads" :key="`thread-${$thread_index}`">
      <b-row class='my-2'>
        <b-col><hr></b-col>
        <b-col cols='4' class='text-center' style='margin-top: 5px;'>
          <span v-if="!recipient">{{thread[0].days_delay}} days with no reply</span>
          <span v-else>Sent {{thread[0].sent_date | datetime}}</span>
        </b-col>
        <b-col><hr></b-col>
      </b-row>

      <b-card class='mt-2'>
        <div v-for="(email, $index) in thread" :key="$index">
          <div>
            <b-row class='my-2' v-if="$index != 0">
              <b-col><hr></b-col>
              <b-col cols='4' class='text-center' style='margin-top: 5px;'>
                <span v-if="!recipient">{{email.days_delay}} days with no reply</span>
                <span v-else>Sent {{email.sent_date | datetime}}</span>
              </b-col>
              <b-col><hr></b-col>
            </b-row>

            <b-row>
              <b-col cols="8">
                <Email :recipient="recipient" :variables="variables" :subject='email.subject' :from_name='email.name || profile.name' :to_email="email.to" :from_email='from_email' :body='email.body' />
              </b-col>
              <b-col cols="4">
                <b-button v-if="!recipient && create" class='float-right' size='sm' @click='() => edit_email(email, $thread_index, $index)'><i class="far fa-edit"></i></b-button>
                <b-button v-if="!recipient && !create" class='float-right mr-2' size='sm' @click='() => email_analytics(email, $thread_index, $index)'><i class="far fa-chart-bar"></i></b-button>
                <b-button v-if='!recipient && !($index === 0 && $thread_index === 0) && create' class='float-right mr-2' variant='danger' size='sm' @click='() => delete_email(email, $thread_index, $index)'><i class="far fa-trash-alt"></i></b-button>
                <b-button v-if='!recipient' size='sm' variant='transparent' class='float-right' :disabled="true">Step {{email.index+1}}</b-button>

                <span v-if="email.opened" v-b-tooltip.hover :title="`Email opened ${email.opened} times`" class='float-right mr-1 pt-2'><i class="fas fa-eye"></i></span>
                <span v-if="email.clicked" v-b-tooltip.hover :title="`Link clicked ${email.clicked} times`" class='float-right mr-1 pt-2'><i class="fas fa-mouse-pointer"></i></span>
                <span v-if="email.played" v-b-tooltip.hover :title="`Video played ${email.played} times`" class='float-right mr-1 pt-2'><i class="fas fa-play"></i></span>
              </b-col>
            </b-row>

          </div>
        </div>
      </b-card>
    </div>

    <b-row>
      <b-col class='text-center'>
        <b-button v-if="create && steps.length < 10" @click="add_email" variant="secondary" class='mb-2'><i class="fad fa-plus-circle"></i> Add email</b-button>
      </b-col>
    </b-row>

    <b-row class='my-2' v-if='!recipient || recipient.finished'>
      <b-col><hr></b-col>
      <!-- TODO use the final step -->
      <b-col cols='4' class='text-center' style='margin-top: 5px;'>
        <span v-if="!recipient">5 days with no reply</span>
        <span v-if='recipient && recipient.finished'>Finished {{recipient.finished | datetime}}</span>
      </b-col>
      <b-col><hr></b-col>
    </b-row>

    <b-card class='text-center' v-if='!recipient || recipient.finished'>
      <b-row>
        <b-col>
          <b-button v-if="!recipient" size='sm' variant='transparent' class='float-right' :disabled="true">Step <span v-if='create'>{{steps.length+1}}</span><span v-else>{{steps.length}}</span></b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <i class="far fa-check-circle"></i>
          <br>
          Person marked as finished
        </b-col>
      </b-row>

    </b-card>

    <EmailEditor ref='email_editor' :sequence="sequence" :projects="projects" :create="create" :email="selected_email" :on_complete="compute_threads" :requires_subject="requires_subject"/>

    <b-modal ref='email_analytics' hide-header ok-only centered size="xl">
      <EmailAnalytics :email="selected_email" />
    </b-modal>
  </div>
</template>



<script>
import Email from '@/components/Email'
import EmailAnalytics from '@/components/EmailAnalytics'
import EmailEditor from '@/components/EmailEditor'
import constants from '@/lib/constants.js'
import { db, FieldValue } from '@/main.js'

// TODO MAX of 10 steps

export default {
  name: 'EmailSequence',
  props: ['sequence', 'steps', 'profile', 'from_email', 'create', 'recipient'],
  components: {Email, EmailEditor, EmailAnalytics},
  firestore: function () {
    let projects = db.collection('project').where('user', '==', db.collection('user').doc(this.profile.id))
    if (this.profile.team_role.role === constants.team_role.admin || this.profile.team_role.role === constants.team_role.manager) {
      projects = db.collection('project').where('team', '==', db.collection('team').doc(this.profile.team.id))
    }

    return {
      projects: projects.orderBy('created', 'desc')
    }
  },
  data() {
    return {
      selected_email: null,
      requires_subject: false,
      threads: [],
      projects: []
    }
  },
  computed: {
    variables() {
      let variables = {
        'first_name': 'John',
        'last_name': 'Smith',
        'organisation': 'Organisation',
        'custom_1': 'Custom 1',
        'custom_2': 'Custom 2',
        'custom_3': 'Custom 3',
        'custom_4': 'Custom 4',
        'unsubscribe_link': 'https://app.vidon.ai/api/unsubscribe'
      }

      for (let project of this.projects) {
        variables[`VIDEO_${project.id}`] = `<a href="${project.video_player_url}" target='_blank'><img src="${project.thumbnail_url}" style="max-width: 360px"/></a>`
      }

      return variables
    }
  },
  watch: {
    steps: {
      deep: true,
      handler: function() {
        this.compute_threads()
      }
    }
  },
  methods: {
    email_analytics(email) {
      this.selected_email = email
      this.$refs.email_analytics.show()
    },
    async add_email() {
      let email = {subject: '', body: '', days_delay: 3, type: 'email'}
      if (!this.create) {
        let doc = db.collection('sequence').doc(this.sequence.id).collection('step').doc()
        await doc.set({
          updated: new Date(),
          created: new Date(),
          user: db.collection('user').doc(this.profile.id),
          uid: this.profile.id,
          team: db.collection('team').doc(this.profile.team.id),
          type: 'email',
          days_delay: email.days_delay,
          subject: email.subject,
          body: email.body,
          sent: 0,
          opened: 0,
          replied: 0,
          clicked: 0,
          bounced: 0,
          unsubscribed: 0,
          auto_replied: 0
        })

        await db.collection('sequence').doc(this.sequence.id).update({updated: new Date(), steps: FieldValue.arrayUnion(doc)})

        email.id = doc.id
        email.ref = doc
      } else {
        this.steps.push(email)
      }

      this.compute_threads()
      this.edit_email(email, this.threads.length-1, this.threads[this.threads.length-1].length-1)
    },
    compute_threads() {
      let threads = []
      let i = 0
      for (let step of this.steps) {
        if (step.type !== 'email') {
          continue
        }

        if (!this.create && !step.id) { // If emails not loaded yet then skip
          break
        }

        step.index = i
        if (!step.subject || step.was_reply) {
          threads[threads.length-1].push(step)
        } else {
          threads.push([step])
        }

        i++
      }

      this.threads = threads
    },
    edit_email(email, thread_index, email_index) {
      this.requires_subject = (thread_index === 0 && email_index === 0)
      this.selected_email = email
      this.$nextTick(() => {
        this.$refs.email_editor.show()
      })
    },
    async delete_email(step, thread_index, email_index) {
      if (thread_index === 0 && email_index === 0) {
        return this.$swal({title: 'Can not delete', text: "You can not delete the first email", icon: 'warning'})
      }

      let result = await this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      })

      if (!result.value) {
        return
      }

      if (this.create) {
        this.steps.splice(step.index, 1)
      } else {
        console.log('removing...', step)
        let ref = db.collection('sequence').doc(this.sequence.id).collection('step').doc(step.id)
        console.log(ref)
        await db.collection('sequence').doc(this.sequence.id).update({updated: new Date(), 'steps': FieldValue.arrayRemove(ref)})
      }


      this.compute_threads()
      // this.$forceUpdate()
    }
  },
  created() {
    this.compute_threads()
  },
  mounted() {
    this.compute_threads()
  }
}
</script>

<style>

.inline-input {
  display: inline-block !important;
  padding: 0px !important;
  margin: 0px !important;
  width: 35px !important;
  height: inherit !important;
  font-size: inherit !important;
  font-family: inherit !important;
  color: inherit !important;
  font-weight: inherit !important;
  border: 0px !important;
  background-color: inherit !important;
}

</style>
